import { Alert } from '@mui/material';
import React from 'react';
import { useAlert } from '@hooks/useAlert';
import { useStyles } from './styles/AlertPopup.styles';

import type { AlertColor } from '@mui/material';

export const AlertPopup = () => {
    const { text, type } = useAlert();

    const styles = useStyles();

    return text && type ? (
        <Alert severity={type as AlertColor} className={styles.alert}>
            {text}
        </Alert>
    ) : (
        <React.Fragment />
    );
};
